import CashbackInfo from './CashbackInfo';

export default CashbackInfo;
